import React from 'react';
import { ExtraProps } from 'react-markdown';
import clx from 'classnames';

const ListRenderer = ({
  node,
  className,
  ...props
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement> & ExtraProps) => (
  <ul
    className={clx(
      `
        pl-4 list-disc
        [&_ul]:list-circle
        [&_ul_ul]:list-square
      `,
      className,
    )}
    {...props}
  />
);

export default ListRenderer;
